import { Component } from "@angular/core"
import { TitleService } from "@puntaje/shared/core"

@Component({
    templateUrl: "generador-diagnostico.component.html"
})
export class GeneradorDiagnosticoComponent {
    constructor() {}
}
